// client/src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // ✅ Import i18n config

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div className="flex items-center justify-center h-screen">
      <div className="text-lg">Φόρτωση... / Loading...</div>
    </div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);